import axios from '@/axiosInterceptor';

const state = () => ({
  collection: [],
  carrierList: [],
  connections: [],
  show: {},
});

const getters = {
  pendingConnectionsCount: (state) => {
    const pendingConnections = state.collection.filter(
      (item) => item.status === 'pending'
    );
    if (!pendingConnections || pendingConnections.length < 1) return 0;
    return pendingConnections.length;
  },
};

// actions

const actions = {
  async getDispatcherConnections({ commit }, query) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/dispatcher_connections',
        { q: query }
      );
      commit('setCollection', res.data);
      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getDispatcherConnection({ commit }, id) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/dispatcher_connections/' + id
      );
      commit('setShow', res.data);
      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async activateDispatcherConnection({ state, commit }, id) {
    try {
      let res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/dispatcher_connections/' +
          id +
          '/activate'
      );
      let newCollection = state.collection.map((el) => {
        return el.id === res.data.id ? res.data : el;
      });
      commit('setCollection', newCollection);
      commit('setShow', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async inactivateDispatcherConnection({ commit, state }, id) {
    try {
      let res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/dispatcher_connections/' +
          id +
          '/inactivate'
      );
      let newCollection = state.collection.map((el) => {
        return el.id === res.data.id ? res.data : el;
      });
      commit('setCollection', newCollection);
      commit('setShow', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getListOfCarriers({ commit }) {
    const buildParams = `page=1&per_page=50&q[s]=id desc`;
    try {
      const res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/dispatcher_connections?' +
          buildParams
      );
      if ([200, 201].includes(res.status)) {
        commit('setConnections', res.data);
        const carrierList = res.data.map((item) => item.carrier);
        commit('setCarriersData', carrierList);
        return carrierList;
      }
      return [];
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setCollection(state, data) {
    state.collection = data;
  },
  setShow(state, data) {
    state.show = data;
  },
  setCarriersData(state, carrierList) {
    state.carrierList = carrierList;
  },
  setConnections(state, connectionList) {
    state.connections = connectionList;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
